import { Component, OnInit, NgZone, Input } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { FingerprintAIO } from '@ionic-native/fingerprint-aio/ngx';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalVariablesService } from '../../../services/global-variables.service';
import { StorageService } from '../../../services/commons/storage.service';
import {Md5} from 'ts-md5/dist/md5';
import { GlobalMethodsService } from '../../../services/global-methods.service';
import { FirebaseCrashlytics } from '@capacitor-community/firebase-crashlytics';

@Component({
  selector: 'app-fingerprint-access',
  templateUrl: './fingerprint-access.component.html',
  styleUrls: ['./fingerprint-access.component.scss'],
})
export class FingerprintAccessComponent implements OnInit {

  @Input('type') type: string;
  @Input('firstUse') firstUse: number;
  @Input('activeBiometric') activeBiometric: number;
  public password = '';
  public user: any;
  public showModal = true;
  constructor(private modalCtrl: ModalController,
              private faio: FingerprintAIO,
              private translate: TranslateConfigService,
              public gvs: GlobalVariablesService,
              public gms: GlobalMethodsService,
              private storage: StorageService) { }

  async ngOnInit() {
    if(this.type === 'faio' && (this.firstUse === 0 || this.activeBiometric)){
      this.showModal = false;
    }
    this.user = await this.storage.getObject(this.gvs.AUTH_KEY);
    if(this.user != null){
      if(this.type === 'faio'){
        await this.faio.isAvailable().then(async result => {
          if(this.user != null && this.user.userName != null && this.activeBiometric){
            await this.fingerPrint();
          }
        }).catch(async error => {
          const message = JSON.stringify(error);
          await FirebaseCrashlytics.recordException({message: message});
        })
      }
    }
  }

  ionViewWillEnter(){
    this.gms.analyticsTrackEvent('openScreen', {screenName: 'Modal Huella', contentGroup: 'Inicio'});
  }

  dismiss(value) {
    this.modalCtrl.dismiss({ confirm: value });
  }

  async fingerPrint(){
    this.faio.show({
      title: await this.translate.getTranslate('MODAL.fingerprintAccess.title'), // (Android Only) | optional | Default: "<APP_NAME> Biometric Sign On"
      description: await this.translate.getTranslate('MODAL.fingerprintAccess.description'), // optional | Default: null
      fallbackButtonTitle: await this.translate.getTranslate('MODAL.fingerprintAccess.fallbackButtonTitle'), // optional | When disableBackup is false defaults to "Use Pin".
      disableBackup: false,  // optional | default: false
      cancelButtonTitle: await this.translate.getTranslate('BUTTON.cancel')
    })
    .then(async (result: any) => {
      this.modalCtrl.dismiss({confirm: true, msgFingerPrint: result});
    })
    .catch(async (error: any) => {
      const message = JSON.stringify(error);
      await FirebaseCrashlytics.recordException({message: message});
      this.modalCtrl.dismiss({confirm: true, msgFingerPrint: error.code});
    });
  }

  async checkPassword(){
    this.user = await this.storage.getObject(this.gvs.AUTH_KEY);
    if(Md5.hashStr(this.password) === this.user.password){
      this.modalCtrl.dismiss({confirm: true, result: true})
    }else{
      this.modalCtrl.dismiss({confirm: true, result: false})
    }
  }
  
}
